var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":"","class-name":"breakpoint overflow-y-auto","z-index":"1000"}},[_c('div',{staticClass:"h-full bg-white text-center breakpoint-container"},[_c('van-empty',{attrs:{"description":"无效链接","image":"error"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }